var React = require('react');

function Bh (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0 0h640v480H0z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","key":1},[React.createElement("path",{"fill":"#e10011","d":"M-32.5 0h720v480h-720z","key":0}),React.createElement("path",{"fill":"#fff","d":"M114.3 479.8l-146.8.2V0h146l94.3 30.4-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5","key":1})])]);
}

Bh.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Bh;

Bh.default = Bh;
